export default __webpack_public_path__ + "static/media/character_01.93dee65b.png";